import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { CoopConsumoFormValidators } from './validators/coop-consumo.form-validators';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { setInitialTipoSezEnte } from '../../../helpers/form-store.helpers';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopConsumoFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Dati identificativi
            `${formPaths.datiIdentificativi}.my_TipoSezEnte`,

            // Scheda altre coop
            `${formPaths.schedaAltreCoop}.my_CkAltreCoopAllegaSchedaConsumo`,
        ]);
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopConsumo: this.fb.group({
                        my_ScConsumoObbl: '',
                        my_Groupconsumo: '',
                        my_CkVendeAiNonSoci: '',
                        my_PuntiVendita: '',
                        my_CkRichiesteLicenze: '',
                        my_CkPossiedeLicenze: '',
                        my_coopConsGenAlimVend: '',
                        my_coopConsAltriGenVend: '',
                        my_GeneriVenduti: '',
                        my_CkSettoriATerzi: '',
                        my_SettoriInGestioneTerzi: '',
                        my_CkOffreAltriServizi: '',
                        my_AltriServiziOfferti: '',
                        my_CkGestisceSezionePrestitoSociale: '',
                        my_CommentoGestionePrestitoSociale: '',
                    }),

                    my_DatiIdentificativi: this.fb.group({
                        my_TipoSezEnte: '',
                    }),

                    my_SchedaCoopAltreCoop: this.fb.group({
                        my_CkAltreCoopAllegaSchedaConsumo: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopConsumoFormValidators,
            }
        );
    }

    protected override afterFormInitialize() {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopConsumo}.my_ScConsumoObbl`);
    }

    protected override beforePopulateForm(myVerbale: MyVerbale) {
        setInitialTipoSezEnte(myVerbale, this.store);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScConsumoObbl);
    }
}
